import { SESSION_PARAMETERS } from "@pdfking/constants/settings"
import object_map from "rfuncs/functions/object_map"

import encode from "./encode"

export default function user_get(string) {
  if (string) {
    const data = encode.loads(string)
    return object_map(
      (v, k) => k,
      v => data[v],
      SESSION_PARAMETERS
    )
  } else {
    return {
      id: null,
      is_staff: false,
      email: null,
      name: null,
      cart_counter: 0,
      has_discount: false,
      signup_time: 0,
    }
  }
}
